import type { FC, ReactNode } from 'react';
import PropTypes from 'prop-types';
import { UseAuth } from 'src/auth/AuthContext';

interface GuardProps {
  children: ReactNode;
}

const GuardGuest: FC<GuardProps> = ({ children }) => {
  return (
    <div><>
    {children}</></div>
  )
}

GuardGuest.propTypes = {
  children: PropTypes.node
}

export default GuardGuest